import styles from './SearchAdvancedFilter.module.css'

interface SearchFilterProps {
  value: { field?: string; query: string } | string | undefined
  onChange: (v: string) => void
  options?: { label: string; value: string }[]
  label?: string
  placeholder?: string
}

/**
 * Single-field text search filter for FilterManager.
 *
 * Renders a labelled text input drawn like `searchAdvanced` without the field selector: the same
 * control in the AppSelect palette, with the search icon. Mounts under the `'search'` key.
 * The input takes the full width of its container (FilterManager wraps it
 * in `col-12` via the `fullWidth` layout).
 *
 * @example
 * <FilterManager
 *   activeFilters={['search']}
 *   filterProps={{ search: { label: 'Поиск по названию', placeholder: 'Введите…' } }}
 *   onApplyFilters={(f) => console.log(f.search)}
 * />
 */
export function SearchFilter({
  value,
  onChange,
  options,
  label = 'Поиск',
  placeholder = 'Введите запрос...',
}: SearchFilterProps) {
  if (value === undefined) return null
  return (
    <>
      {label && (
        <label className='fs-6 form-label fw-bolder text-dark'>{label}</label>
      )}
      <div className={styles.field}>
        <span className='svg-icon svg-icon-3 svg-icon-gray-500 ms-4'>
          <i className='fa fa-search'></i>
        </span>
        <input
          type='text'
          className={`form-control ps-3 ${styles.input}`}
          placeholder={placeholder}
          value={typeof value === 'string' ? value : value.query}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </>
  )
}
